import React from 'react';
import "../../component/styles/styles.scss";
import Container from "react-bootstrap/Container";
import Redpalette from "./red-palette";
import Premiumpalette from "./premium-palette";
import Bluepalette from "./blue-palette";
import Greenpalette from "./green-palette";
import Yellowpalette from "./yellow-palette";
import Mixcolorpalette from "./mix-colors";
import ScrollToTop from "react-scroll-to-top";
import Drawercomponent from "../../component/drawer";
import Drawer from '@mui/material/Drawer';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Usesolidcolorcontext } from '../../utils/Hooks';

export default function Solidcolorwrapper() {
    const { toggleDrawer, open } = Usesolidcolorcontext();

    return (
        <Container fluid>
            <div className="ctc-btn" onClick={toggleDrawer(true)}><p>Open the color palette</p></div>
            <Drawer open={open} onClose={toggleDrawer(false)} anchor="right">
                <Drawercomponent open={open} toggleDrawer={toggleDrawer} />
            </Drawer>
            <div className="red-color-pallete-wrapper">
                <h1 className=" text-red-500">Shades</h1>
                <p>Dive into a stunning array of solid colors for your next project.</p>
                <p>Click to copy!</p>
                <p>OR <ArrowRightAltIcon /></p>
                <Premiumpalette />
            </div>
            <Redpalette />
            <Bluepalette />
            <Greenpalette />
            <Yellowpalette />
            <Mixcolorpalette />
            <ScrollToTop smooth color="#111" top="1000" />
        </Container>
    )
}
